export default {
  email: 'email',
  textSms: 'text_sms',
  voice: 'voice',
};
